// extracted by css-extract-rspack-plugin
export default {"root":"root-D758Hm","rowLabel":"rowLabel-K_gMGh","rowLabelInner":"rowLabelInner-e2vvOk"};